<div class="col-md-12 mt-3" *ngIf="resourceDataSource && resourceDataSource.data.length >0">
    <mat-form-field class="float-right">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>

    <div class="row">
        <div class="col-md-12 mt-2">
            <div class="row" *ngIf="success.length > 0" class="padding-b-15">
                <div class="alert alert-success">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeSuccess()">×</button>
                    <span>The following Support Topic(s) are succesfully published.</span>
                    <ul>
                        <li *ngFor="let feature of success">{{feature}}</li>
                    </ul>
                </div>
            </div>
            <div class="row" *ngIf="failure.length > 0" class="padding-b-15">
                <div class="alert alert-danger">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeFailure()">×</button>
                    <span>The following Support Topic(s) does not have a model mapped. Please complete the model mapping before
                        publishing the Support Topic(s)</span>
                    <ul>
                        <li *ngFor="let feature of failure">{{feature}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- Material Table -->
    <table aria-describedby="draft-feature" aria-labelledby="draft-feature" mat-table [dataSource]="resourceDataSource" matSort
        class="col-md-12 draft-table mat-elevation-z8">
        <ng-container matColumnDef="select">
            <th id="draft-select" class="resource-header-card" mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element">
                <mat-checkbox class="pl-checkbox" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="controls.controlName">
            <th id="draft-SP" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Support Topics </th>
            <td mat-cell *matCellDef="let element" (click)="navigateToSupportTopic(element)" class="text-decoration-line action-control-delete cursor-pointer">
                {{element.controls[0].featureName}} </td>
        </ng-container>

        <ng-container matColumnDef="featureType">
            <th id="draft-type" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Support Topics Type </th>
            <td mat-cell *matCellDef="let element"> {{element.featureType | capitalizeStr}} </td>
        </ng-container>

        <ng-container matColumnDef="lastModifiedBy">
            <th id="draft-last-modified-by" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified By </th>
            <td mat-cell *matCellDef="let element"> {{element.lastModifiedBy ? element.lastModifiedBy : 'System'}} </td>
        </ng-container>

        <ng-container matColumnDef="lastModifiedDate">
            <th id="draft-last-modified-date" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.lastUpdatedDate" | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.lastModifiedDate | date:'short'}} </td>
        </ng-container>

        <ng-container matColumnDef="category" style="display:none;">
            <th id="draft-last-modified-date" class="resource-header-card" style="display:none;" mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "Label.lastUpdatedDate" | translate}} </th>
            <td mat-cell *matCellDef="let element" style="display:none;"> {{element.category}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


    <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
    <div class="publish-action-controls">
        <!-- <span>
            <button [disabled]="this.selection.selected.length < 1" class="ml-2 btn btn-browse" (click)="deleteSelectedFeatures()" type="button">Delete</button>
        </span> -->
        <span>
            <button [disabled]="this.selection.selected.length < 1" class="ml-2 btn btn-browse" (click)="previewFeature()" type="button">Preview</button>
        </span>
        <span *ngIf="hasPermission">
            <button [disabled]="this.selection.selected.length < 1" class="ml-2 btn btn-browse" (click)="publishFeature()" type="button">Publish</button>
        </span>
        <!-- <span>
            <button class="ml-2 btn btn-browse" type="button">Reject</button>
        </span> -->
    </div>
</div>